import { defineStore } from "pinia";
import { computed, watch, onMounted } from "vue";
import EnvironmentBrandingDTO = App.Data.EnvironmentBrandingDTO;
import { useLocalStorage } from "@vueuse/core";
import { useApiClient } from "@/api/client";

export const useBrandingStore = defineStore("useBrandingStore", () => {
	const initialValue: EnvironmentBrandingDTO = {
		primaryColor: "primary",
		secondaryColor: "secondary",
		logoLight: null,
		logoDark: null,
		logoSquare: null,
		useLightLogoOnLoginScreen: null,
		faviconUrl: null,
		siteTitle: null,
	};

	const customLoginScreen = useLocalStorage("customLoginScreen", initialValue);

	const primaryColor = computed(() => customLoginScreen.value.primaryColor);
	const secondaryColor = computed(() => customLoginScreen.value.secondaryColor);
	const logoLight = computed(() => customLoginScreen.value.logoLight);
	const logoDark = computed(() => customLoginScreen.value.logoDark);
	const logoSquare = computed(() => customLoginScreen.value.logoSquare);
	const useLightLogoOnLoginScreen = computed(
		() => customLoginScreen.value.useLightLogoOnLoginScreen
	);
	const faviconUrl = computed(() => customLoginScreen.value.faviconUrl);
	const siteTitle = computed(() => customLoginScreen.value.siteTitle);

	const setFavicon = () => {
		let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
		if (!link) {
			link = document.createElement("link");
			link.rel = "icon";
			document.head.appendChild(link);
		}
		if (customLoginScreen.value.faviconUrl) {
			link.href = customLoginScreen.value.faviconUrl;
		}

		if (customLoginScreen.value.siteTitle) {
			document.title = customLoginScreen.value.siteTitle;
		}
	};

	const setCustomValues = (branding: EnvironmentBrandingDTO) => {
		Object.entries(branding).forEach(([key, value]) => {
			if (value !== null) {
				customLoginScreen.value[key] = value;
			}
		});
	};

	watch(
		customLoginScreen,
		() => {
			setFavicon();
		},
		{ deep: true, immediate: true }
	);

	const fetchCustomValues = async () => {
		const response = await useApiClient("login").getCustomLoginScreen();

		if (response.isOk()) {
			setCustomValues(response.value);
		}
	};

	return {
		primaryColor,
		secondaryColor,
		logoLight,
		logoDark,
		logoSquare,
		useLightLogoOnLoginScreen,
		faviconUrl,
		siteTitle,
		fetchCustomValues,
	};
});
